import { Conference, Language } from '../../../types';

export type Participant = {
  _: 'Participant';
  id: string;
  userId: string;
  appId: string;
  name: string;
  role: ParticipantRole;
  language: Language;
  conference: Conference;
  token: string;
};

export enum ParticipantRole {
  MODERATOR = 'moderator',
  PRESENTER = 'presenter',
  SPEAKER = 'speaker',
  ATTENDEE = 'attendee',
}

export type HandRaisedParticipant = {
  id: string;
  participantId: string;
  raisedAt: number;
};

export enum ParticipantRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export type CreateParticipantParams = {
  roomId: string;
  language?: Language;
};

export type UpdateParticipantParams = {
  participantId: string;
  language?: Language;
  role?: ParticipantRole;
};

export type ToggleCommandParticipant = {
  participantId: string;
  raisedAt: number;
};
